import React, { useContext, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LanguageContext from '../../contexts/languageContext'
import { getLanguageFromUrl } from '../../utils/navigation'
import Header from '../../components/Header'
import ChangelogFilter from '../../components/ChangelogFilter'
import * as DataHelpers from '../../helpers/changelog/data'
import { useChangelogFilter, useChangelogFilterOnChange, useChangelogOnSelectFilter, useClearFilter } from '../../hooks/useChangelogFilter'
import ChangelogNoResult from '../../components/ChangelogNoResult'
import ChangelogContent from '../../components/ChangelogContent'
import IsPageUseful from '../../components/IsPageUseful'
import Newsletter from '../../components/Newsletter'
import Seo from '../../components/SEO'
import styles from './styles.module.css'
import useMounted from '../../hooks/useMounted'

const ChangelogLayout = ({ data: queryData, location, lang }) => {
  const { baseFilter, initialData } = DataHelpers.buildChangelogData(queryData.allMarkdownRemark)
  const [data, setData] = useState(initialData)
  const { initialFilter, filter, setFilter } = useChangelogFilter(baseFilter)
  const { onSelectFilter } = useChangelogOnSelectFilter(filter, setFilter)
  const { onClearFilter } = useClearFilter(initialFilter, setFilter)
  const { setLanguage } = useContext(LanguageContext)
  const { t } = useTranslation()
  const hasMounted = useMounted()

  useChangelogFilterOnChange(initialData, setData, filter)

  useEffect(() => {
    setLanguage(getLanguageFromUrl(location.pathname))
  }, [setLanguage, location.pathname])

  return (
    hasMounted && (
      <>
        <Seo
          title="Changelog"
          distinctLangs={['pt-BR', 'en', 'es']}
          locale={lang}
          tags={['changelog']}
          url={location && location.pathname}
        />

        <div className={styles.changelogWrapper}>
          <Header
            title="Changelog"
            buttonLink="urlChangelogHotmart"
            buttonText={t('changelog.page.buttonHeader')}
            description={t('changelog.page.description')}
            isSecundaryButton={true}
            isExternalLink={false}
          />
          <div className={styles.changelogContainer}>
            <div className={styles.changelogContent}>
              <ChangelogFilter filter={filter} onSelectFilter={onSelectFilter} onClearFilter={onClearFilter} />
              {data.length ? <ChangelogContent data={data} /> : <ChangelogNoResult onClearFilter={onClearFilter} />}
            </div>
          </div>
          <IsPageUseful url={location.href} />
          <Newsletter />
        </div>
      </>
    )
  )
}

export default ChangelogLayout
